
import { Button, Typography, Dialog, DialogContent, DialogActions, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { CloseDialogAction } from '../../../../components/shared/dialogs/CloseDialogAction';
import { ScheduleCreateContext, ScheduleCreateValues } from '../../contexts/ScheduleCreateContext';

const ScheduleCreateDeleteProductTypeModal = () => {
  const { isProductTypeDeleteModalOpen,
    handleClose,
    deleteProductTypes,
    productTypeData,
    productType } = useContext(ScheduleCreateContext) as ScheduleCreateValues;

  const { t } = useTranslation('createStockCount');

  const handleConfirm = () => {
    const data = productType ? productTypeData?.filter(item => item !== productType) : [];
    deleteProductTypes(data);
  };

  return (
    <Dialog open={isProductTypeDeleteModalOpen}
      onClose={handleClose}
      maxWidth='sm'
      fullWidth>
      <DialogTitle>
        {t('deleteType')}
        <CloseDialogAction onCancel={handleClose} />
      </DialogTitle>
      <DialogContent>
        <Typography>{t('approvalTypeDialogMessage')}</Typography>
      </DialogContent>
      <DialogActions >
        <Button
          variant="secondary"
          size='lg'
          onClick={handleClose}> {t('cancel')}</Button>
        <Button variant="bad"
          size='lg'
          onClick={handleConfirm}>
          {t('confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ScheduleCreateDeleteProductTypeModal;